import ErrorPopup from './ErrorPopup';

export default ErrorPopup;
